<div class="section-tabs" *ngIf="sections.length > 1">
  <button
    type="button"
    class="section-tab"
    *ngFor="let section of sections; let i = index"
    [class.active]="i === activeIndex"
    (click)="select(i)"
  >
    {{ section.name }}
  </button>
</div>
